export enum AssetFileTypeEnum {
  IMAGE = "image",
  AUDIO = "audio",
  SPRITE = "sprite",
  VIDEO = "video",
}

export enum DialogueModeEnum {
  HIDE_DIALOGUE = "hide-dialogue",
}
